import React, { useEffect, useRef } from 'react';

import Navbar from '../components/Navbar';
import TranslateUploader from '../components/Translate/TranslateUploader';
import { supportedLanguages } from '../utils/config';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { EPaymentType, SetLoading, SetModalPayment } from '../store/layout.slice';
import PaymentModal from '../components/Modals/Payment.modal';
import { EUploadStatus } from '../@types/Upload';
import { IsValidEmail } from '../utils/validator';
import { SetUploadStatus, SetUploadedUrl } from '../store/translate.page.slice';

function Translate() {
    const dispatch = useAppDispatch();

    const uploadStatus = useAppSelector((state) => state.pageTranslate.uploader.status);
    const uploader = useAppSelector((state) => state.pageTranslate.uploader);
    
    const refSourceLang = useRef<HTMLSelectElement>(null);
    const refTargetLang = useRef<HTMLSelectElement>(null);
    const refEmail = useRef<HTMLInputElement>(null);

    useEffect(() => {
        dispatch(SetUploadStatus(EUploadStatus.NoFileSelected));
        dispatch(SetUploadedUrl(''));
    }, [])

    const onClickCheckout = async () => {
        if(uploadStatus !== EUploadStatus.Uploaded) {
            alert(`No file is uploaded.`);
            return;
        }

        let sourceLang = refSourceLang.current?.value || '';
        let targetLang = refTargetLang.current?.value || '';

        if(sourceLang.length <= 0) { refSourceLang.current?.focus(); return; }
        if(targetLang.length <= 0) { refTargetLang.current?.focus(); return; }
        if(sourceLang === targetLang) { alert(`Original language and desired language must be different.`); return; }

        let email = refEmail.current?.value || '';
        if(email.length <= 0 || !IsValidEmail(email)) { refEmail.current?.focus(); return; }

        dispatch(SetModalPayment({ 
            show: true, 
            type: EPaymentType.Translate, 
            data: {
                email,
                fileName: uploader.file.name,
                fileUrl: uploader.uploadedUrl,
                sourceLang,
                targetLang
            } 
        }));

        // Test
        //dispatch(SetModalPayment({ show: true }));
    }

    return (
        <div>
            {/* <Navbar page="translate"/> */ }
            <div className='anim-fade-in max-w-5xl mx-auto pt-4 md:pt-10 px-5 pb-20'>
                {/* 
                <h3 className='text-4xl md:text-5xl font-bold tracking-wide mb-1 md:mb-2 text-center'>Translate Subtitle</h3>
                <p className='text-2xl mb-10 md:mb-20 text-gray-700 text-center'>Translate your subtitles into desired languages.</p>*/}
                <TranslateUploader/>
                <div className='grid grid-cols-2 gap-4 mb-5'>
                    <div>
                        <label htmlFor="originalLanguage" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Original Language</label>
                        <select ref={refSourceLang} id="originalLanguage" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                            <option value="" selected>Choose a language</option>
                            { supportedLanguages.map((l) =>  <option value={l.code}>{ l.label }</option>) }
                        </select>
                    </div>
                    <div>
                        <label htmlFor="targetLanguage" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Desired Language</label>
                        <select ref={refTargetLang} id="targetLanguage" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                            <option value="" selected>Choose a language</option>
                            { supportedLanguages.map((l) =>  <option value={l.code}>{ l.label }</option>) }
                        </select>
                    </div>
                </div>
                <div className='grid grid-cols-2 gap-4 mb-5'>
                    <div>
                        <label  data-tooltip-target="tooltip-email"  htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Email Address<i className="fa-solid fa-circle-info ml-1.5"></i></label>
                        <input ref={refEmail} type="email" id="email" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="you@mail.com" required/>
                        <div id="tooltip-email" role="tooltip" className="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700">
                            Translated subtitle file will be sent to your email, make sure it's correct :)
                            <div className="tooltip-arrow" data-popper-arrow></div>
                        </div>
                    </div>
                </div>
                <hr className="w-48 h-1 mx-auto my-4 bg-gray-100 border-0 rounded md:my-10 dark:bg-gray-700 mb-5"></hr>
                <div className='flex justify-between items-center flex-row p-6 bg-white border border-gray-200 rounded-lg shadow'>
                    <div>
                        <p className='text-gray-500 mb-0 leading-4'>Total Cost</p>
                        <p>
                            <span className="text-xl font-semibold">$</span>
                            <span className="text-2xl font-bold tracking-tight">5</span>
                        </p>
                    </div>
                    <button onClick={onClickCheckout} className="inline-flex items-center px-4 py-2 text-sm font-medium text-center text-white bg-gray-800 rounded-lg hover:bg-gray-900 active:bg-gray-900"><i className="fa-solid fa-cart-shopping mr-1.5"></i>Checkout</button>
                </div>
            </div>
            <PaymentModal/>
        </div>
    )
}

export default React.memo(Translate);